import { AxiosResponse } from 'axios';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  activeCountriesResponseMap,
  filterParametersResponseMap,
  masterDataResponseMap,
} from '../../helpers';
import {
  AppStorage,
  GetActiveCountriesResponse,
  GetActiveStoresResponse,
  GetParametersResponse,
  ConciliationApi,
  GetOpStructuresResponse,
} from '../../services';
import { ActionType as UserActionType } from '../user/types';
import {
  activeCountriesFailure,
  activeCountriesRequested,
  activeCountriesSuccess,
  masterDataFailure,
  masterDataRequested,
  masterDataSuccess,
  parametersFailure,
  parametersRequested,
  parametersSuccess,
} from './actionCreators';

import { HttpRequestError } from '../../types';
import { findAllRequest } from '../dashboard/actionCreators';

function* getAppParameters() {
  yield put(masterDataRequested());

  try {
    let masterData = AppStorage.getMasterData();

    if (
      !masterData ||
      !masterData.federativeEntities ||
      !masterData.regionalManagements?.length ||
      !masterData.regions?.length ||
      !masterData.managements?.length ||
      !masterData.supervisions?.length ||
      !masterData.agreements?.length ||
      !masterData.companies?.length
    ) {
      const [
        opStructuresResponse,
        /*  posTypesResponse, federativeEntitiesResponse, */ activeStoresResponse,
      ]: [
        AxiosResponse<GetOpStructuresResponse>,
        // AxiosResponse<GetPosTypesResponse>,
        // AxiosResponse<Record<string, string[]>>,
        AxiosResponse<GetActiveStoresResponse>
      ] = yield all([
        call(ConciliationApi.getOpStructures),
        // call(SalesParametersApi.getPosTypes),
        // call(SalesParametersApi.getFederativeEntities),
        call(ConciliationApi.getStores),
      ]);

      const { data: opStructuresData } = opStructuresResponse;
      // const { data: posTypesData } = posTypesResponse;
      // const { data: federativeEntitiesData } = federativeEntitiesResponse;
      const { data: activeStoresData } = activeStoresResponse;

      // masterData = masterDataResponseMap(opStructuresData, posTypesData, federativeEntitiesData);
      masterData = masterDataResponseMap(opStructuresData, activeStoresData);

      AppStorage.setMasterData(masterData);
    }

    yield put(masterDataSuccess(masterData));
  } catch (error) {
    yield put(masterDataFailure(error as HttpRequestError));
  }
}

function* getActiveCountries() {
  yield put(activeCountriesRequested());

  try {
    const activeCountriesResponse: AxiosResponse<GetActiveCountriesResponse> = yield call(
      ConciliationApi.getActiveCountries
    );

    const { data: activeCountriesData } = activeCountriesResponse;

    const activeCountries = activeCountriesResponseMap(activeCountriesData);

    yield put(activeCountriesSuccess(activeCountries));
    yield put(findAllRequest());
  } catch (error) {
    yield put(activeCountriesFailure(error as HttpRequestError));
  }
}

function* getParameters() {
  yield put(parametersRequested());
  try {
    const parametersResponse: AxiosResponse<GetParametersResponse> = yield call(
      ConciliationApi.getParameters
    );
    const { data: parametersData } = parametersResponse;
    const parameters = {
      ...filterParametersResponseMap(parametersData),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      reprocess: (parametersData as any).reprocess,
      synchro: (parametersData as any).synchro,
    };
    yield put(parametersSuccess(parameters));
  } catch (error) {
    yield put(parametersFailure(error as HttpRequestError));
  }
}

export default [
  takeLatest(UserActionType.permissionsSuccess, getAppParameters),
  takeLatest(UserActionType.permissionsSuccess, getActiveCountries),
  takeLatest(UserActionType.permissionsSuccess, getParameters),
];
